<template>
  <div class="profileView responsive-height">
    <v-container class="main-container">
      <v-row>
        <PartnerInfoCard :summary="summary" />
        <PartnerBalanceCard :summary="summary" />
      </v-row>
      <v-row>
        <v-col lg="12" md="12" sm="12" cols="12">
          <v-card elevation="0" class="all-trade-tab rounded-0 deposit-tab">
            <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
              <v-tab v-if="$canRoute('client-tree-partner-tab') > 0"> Client Tree </v-tab>
              <v-tab v-if="$canRoute('commission-history-partner-tab') > 0"> Commission History </v-tab>
              <v-tab v-if="$canRoute('commission-rates-partner-tab') > 0"> Commission Rates </v-tab>
              <v-tab v-if="$canRoute('withdraw-partner-tab') > 0"> Withdraw </v-tab>
              <v-tab v-if="$canRoute('level-unlock-settings-partner-tab') > 0"> Level Unlock Settings </v-tab>
              
              <v-tab-item v-if="$canRoute('client-tree-partner-tab') > 0">
                <client-tree-tab></client-tree-tab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('commission-history-partner-tab') > 0">
                <commission-history-tab></commission-history-tab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('commission-rates-partner-tab') > 0">
                <advanced-rates-tab></advanced-rates-tab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('withdraw-partner-tab') > 0">
                <transaction-tab></transaction-tab>
              </v-tab-item>
              <v-tab-item v-if="$canRoute('level-unlock-settings-partner-tab') > 0">
                <level-unlock-settings></level-unlock-settings>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import AdvancedRatesTab from '@/components/Partners/AdvancedRatesTab.vue';
import ClientTreeTab from '@/components/Partners/ClientTreeTab.vue';
import CommissionHistoryTab from '@/components/Partners/CommissionHistoryTab.vue';
import LevelUnlockSettings from '@/components/Partners/LevelUnlockSettings.vue';
import PartnerBalanceCard from '@/components/Partners/PartnerBalanceCard.vue';
import PartnerInfoCard from '@/components/Partners/PartnerInfoCard.vue';
import TransactionTab from '@/components/Partners/TransactionTab.vue';
import { mapState, mapActions } from "vuex";
import { PARTNERLIST__ACTIONS } from "@/store/action-types";

export default {
  components: {
    PartnerInfoCard,
    PartnerBalanceCard,
    ClientTreeTab,
    CommissionHistoryTab,
    TransactionTab,
    LevelUnlockSettings,
    AdvancedRatesTab
  },
  computed: {
    ...mapState("partnerlist", ["summary"]),
  },
  methods: {
    ...mapActions("partnerlist", [PARTNERLIST__ACTIONS.PARTNERSUMMARY]),
  },
  async mounted() {
    
    await this[PARTNERLIST__ACTIONS.PARTNERSUMMARY]({ partner_id: this.$route.query.id });
    LevelUnlockSettings,
      AdvancedRatesTab
  },

};
</script>
